// src/pages/OpportunityDetail.jsx
import { useParams, useNavigate } from 'react-router-dom';
import { useUIStore } from '../store/uiStore';
import { C } from '../styles/tokens';

export default function OpportunityDetail() {
  const { id }    = useParams();
  const navigate  = useNavigate();
  const { openAuthModal } = useUIStore();

  return (
    <div style={{ background: C.bg, paddingTop: 64, minHeight: '100vh' }}>
      <div className="container" style={{ padding: '48px clamp(16px,4vw,28px)' }}>
        <button onClick={() => navigate('/opportunities')} style={{ background: 'none', border: 'none', color: C.magenta, cursor: 'pointer', fontSize: 14, fontWeight: 600, marginBottom: 24, display: 'flex', alignItems: 'center', gap: 6 }}>← Back to Opportunities</button>
        <div className="card" style={{ padding: 40, maxWidth: 760 }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg,${C.magenta},${C.violet})` }} />
          <h1 className="syne" style={{ fontSize: 28, fontWeight: 800, marginBottom: 8 }}>Senior Product Designer</h1>
          <p style={{ color: 'rgba(255,255,255,.45)', marginBottom: 28 }}>TechFlow Global · Remote · USA</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 14, marginBottom: 32 }}>
            {[['🎯 AI Match', '96%', C.magenta], ['💰 Pay', '180–240 ONT/mo', C.success], ['📅 Posted', '2 hours ago', C.info]].map(([l, v, c]) => (
              <div key={l} style={{ padding: 16, borderRadius: 12, background: `${c}08`, border: `1px solid ${c}20`, textAlign: 'center' }}>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,.45)', marginBottom: 4 }}>{l}</div>
                <div className="syne" style={{ fontSize: 16, fontWeight: 800, color: c }}>{v}</div>
              </div>
            ))}
          </div>
          <h3 className="syne" style={{ fontSize: 16, fontWeight: 700, marginBottom: 10 }}>About This Role</h3>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,.55)', lineHeight: 1.8, marginBottom: 24 }}>
            Lead product design across our core platform. You will collaborate with cross-functional teams spanning engineering, product, and growth to ship high-quality features used by millions of users worldwide. We are a remote-first, async-friendly culture that values deep work and clear communication.
          </p>
          <h3 className="syne" style={{ fontSize: 16, fontWeight: 700, marginBottom: 10 }}>Requirements</h3>
          <ul style={{ color: 'rgba(255,255,255,.55)', fontSize: 14, lineHeight: 2, paddingLeft: 20, marginBottom: 24 }}>
            <li>5+ years of product design experience</li>
            <li>Expert in Figma and design systems</li>
            <li>Strong UX research and prototyping skills</li>
            <li>Experience shipping B2B/B2C SaaS products</li>
          </ul>
          <button onClick={() => openAuthModal('register')} style={{ padding: '14px 36px', background: `linear-gradient(135deg,${C.magenta},${C.violet})`, border: 'none', borderRadius: 9, color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: "'Syne',sans-serif" }}>Apply Now →</button>
        </div>
      </div>
    </div>
  );
}
